import { define } from './define';

// Words used all over the app: buttons, loading and empty states, generic errors.
export const common = define({
  es: {
    'common.loading': 'Cargando…',
    'common.saving': 'Guardando…',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.delete': 'Borrar',
    'common.edit': 'Editar',
    'common.add': 'Añadir',
    'common.create': 'Crear',
    'common.back': 'Volver',
    'common.retry': 'Reintentar',
    'common.confirm': 'Confirmar',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.none': 'Ninguno',
    'common.optional': '(opcional)',
    'common.search': 'Buscar',
    'common.all': 'Todas',
    'common.copy': 'Copiar',
    'common.copied': 'Copiado',
    'common.copyFailed': 'No se ha podido copiar: selecciona el texto y cópialo a mano',
    'common.download': 'Descargar',
    'common.open': 'Abrir',
    'common.more': 'Más',
    'common.notFound': 'Página no encontrada',
    'common.somethingWrong': 'Algo ha fallado',
    'common.invalidDate': 'Elige una fecha y una hora válidas',
    'common.ai': 'IA',
    'common.agent': 'Agente',
    'common.comments': { zero: 'Sin comentarios', one: '{count} comentario', other: '{count} comentarios' },
    'common.openComments': { one: '{count} abierto', other: '{count} abiertos' },
    'common.variants': { one: '{count} variante', other: '{count} variantes' },
    'common.pages': { one: '{count} página', other: '{count} páginas' },
    'common.items': { one: '{count} elemento', other: '{count} elementos' },
  },
  en: {
    'common.loading': 'Loading…',
    'common.saving': 'Saving…',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.create': 'Create',
    'common.back': 'Back',
    'common.retry': 'Try again',
    'common.confirm': 'Confirm',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.none': 'None',
    'common.optional': '(optional)',
    'common.search': 'Search',
    'common.all': 'All',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.copyFailed': 'Could not copy: select the text and copy it by hand',
    'common.download': 'Download',
    'common.open': 'Open',
    'common.more': 'More',
    'common.notFound': 'Page not found',
    'common.somethingWrong': 'Something went wrong',
    'common.invalidDate': 'Pick a valid date and time',
    'common.ai': 'AI',
    'common.agent': 'Agent',
    'common.comments': { zero: 'No comments', one: '{count} comment', other: '{count} comments' },
    'common.openComments': { one: '{count} open', other: '{count} open' },
    'common.variants': { one: '{count} variant', other: '{count} variants' },
    'common.pages': { one: '{count} page', other: '{count} pages' },
    'common.items': { one: '{count} item', other: '{count} items' },
  },
});
